export const SUBSCRIPTION_PLAN_CATEGORIES = [
  "free",
  "paid",
  "trial",
  "demo",
  "test",
] as const;
